import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useLocation } from 'react-router-dom';
import AnalyticsIcon from '../../../assets/svg/left-bar/AnalyticsIcon';
import CustomersIcon from '../../../assets/svg/left-bar/CustomersIcon';
import DriversIcon from '../../../assets/svg/left-bar/DriversIcon';
import PlannerIcon from '../../../assets/svg/left-bar/PlannerIcon';
import StopsIcon from '../../../assets/svg/left-bar/StopsIcon';
import * as routing from '../../../constants/Routing';
import { useRetrieveActiveProject } from '../../../hooks/project/useRetrieveActiveProject';
import Text from '../../../react-components/Text';
import { SideBarSectionsMenuItem } from './SideBarSectionsMenuItem';

export const SideBarSections = () => {
  const [tab, setTab] = useState(0);
  const [currentLocation, setCurrentLocation] = useState<string | undefined>();

  const { data: activeProject } = useRetrieveActiveProject();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!currentLocation || currentLocation !== location.pathname) {
      setCurrentLocation(location.pathname);
      if (location.pathname.includes(`${activeProject?.id ?? ``}/analytics`)) {
        setTab(5);
      } else if (location.pathname.includes(`${activeProject?.id ?? ``}/customers`)) {
        setTab(4);
      } else if (location.pathname.includes(`${activeProject?.id ?? ``}/drivers`)) {
        setTab(3);
      } else if (location.pathname.includes(`${activeProject?.id ?? ``}/stops`)) {
        setTab(2);
      } else if (location.pathname.includes(`${activeProject?.id ?? ``}/planner`)) {
        setTab(1);
      } else {
        setTab(0);
      }
    }
  }, [currentLocation, location, setTab, setCurrentLocation, activeProject]);

  const handleChangeTab = (selectedTab: number) => {
    switch (selectedTab) {
      case 1:
        navigate(`${routing.PLANNER.ROOT.replace(`:projectId`, activeProject?.id ?? ``)}`);
        break;
      case 2:
        navigate(`${routing.STOPS.ROOT.replace(`:projectId`, activeProject?.id ?? ``)}`);
        break;
      case 3:
        navigate(`${routing.DRIVERS.ROOT.replace(`:projectId`, activeProject?.id ?? ``)}`);
        break;
      case 4:
        navigate(`${routing.CUSTOMERS.ROOT.replace(`:projectId`, activeProject?.id ?? ``)}`);
        break;
      case 5:
        navigate(`${routing.PROJECT_ANALYTICS.SUMMARY.replace(`:projectId`, activeProject?.id ?? ``)}`);
        break;
      default:
        navigate(`${routing.PLANNER.ROOT.replace(`:projectId`, activeProject?.id ?? ``)}`);
    }

    setTab(selectedTab);
  };

  const sideBarSections = [
    {
      id: `planner`,
      label: <Text intlId="project.planner" variant="body" style={{ cursor: `pointer`, color: `white` }} />,
      icon: <PlannerIcon key="planning-icon" isSelected={tab === 1} />,
      onClick: () => (activeProject ? handleChangeTab(1) : null),
      selected: tab === 1,
    },
    {
      id: `stops`,
      label: <Text intlId="project.stops" variant="body" style={{ cursor: `pointer`, color: `white` }} />,
      icon: <StopsIcon key="stops-icon" isSelected={tab === 2} />,
      onClick: () => (activeProject ? handleChangeTab(2) : null),
      selected: tab === 2,
    },
    {
      id: `drivers`,
      label: <Text intlId="project.drivers" variant="body" style={{ cursor: `pointer`, color: `white` }} />,
      icon: <DriversIcon key="drivers-icon" isSelected={tab === 3} />,
      onClick: () => (activeProject ? handleChangeTab(3) : null),
      selected: tab === 3,
    },
    {
      id: `customers`,
      label: <Text intlId="project.customers" variant="body" style={{ cursor: `pointer`, color: `white` }} />,
      icon: <CustomersIcon key="customers-icon" isSelected={tab === 4} />,
      onClick: () => (activeProject ? handleChangeTab(4) : null),
      selected: tab === 4,
    },
    {
      id: `analytics`,
      label: <Text intlId="project_analytics.title" variant="body" style={{ cursor: `pointer`, color: `white` }} />,
      icon: <AnalyticsIcon key="analytics-icon" isSelected={tab === 5} />,
      onClick: () => (activeProject ? handleChangeTab(5) : null),
      selected: tab === 5,
    },
  ];

  return (
    <>
      {sideBarSections?.map((element) => {
        return (
          <SideBarSectionsMenuItem
            key={element.id}
            id={element.id}
            label={element.label}
            icon={element.icon}
            onClick={element.onClick}
            selected={element.selected}
          />
        );
      })}
    </>
  );
};
